const envStoragePrefix =
  typeof window === "undefined"
    ? ""
    : window.location.origin.replace(/[^a-zA-Z0-9]/g, "_");

export const getEnvStorageKey = (key) =>
  envStoragePrefix ? `${envStoragePrefix}_${key}` : key;
